import React from 'react';
import PropTypes from 'prop-types';

import GenericIcon from 'src/components/generic-icon/GenericIcon';

function CompanyRow(props) {
  return !props.company ? null : (
    <div className="free-row">
      <div className="prop-img">
        <div className="prop-left">
          <GenericIcon className="building-icon icon-color2" />
        </div>
        <div
          className="prop-right"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <a className="link colored-link">{props.company}</a>
        </div>
      </div>
    </div>
  );
}

CompanyRow.propTypes = {
  company: PropTypes.string,
};

export default CompanyRow;
